(function () {
  'use strict';

  let modalListenersBound = false;

  function bindModalListeners(modal) {
    if (!modal || modalListenersBound) return;

    const cancelButton = modal.querySelector('[data-store-switcher-cancel]');
    const continueButton = modal.querySelector('[data-store-switcher-continue]');

    if (cancelButton) {
      cancelButton.addEventListener('click', () => {
        modal.hide();
      });
    }

    if (continueButton) {
      continueButton.addEventListener('click', () => {
        const redirectUrl = modal.dataset.redirectUrl;
        if (redirectUrl) {
          window.location.href = redirectUrl;
        }
      });
    }

    modalListenersBound = true;
  }

  function handleTriggerClick(event) {
    const trigger = event.target.closest('[data-store-switcher-trigger]');
    if (!trigger) return;

    const modal = document.getElementById('StoreSwitcherModal');
    if (!modal || typeof modal.show !== 'function') return;

    event.preventDefault();
    modal.dataset.redirectUrl = trigger.getAttribute('data-store-switcher-url') || '';
    modal.show(trigger);
  }

  function initStoreSwitcher() {
    const modal = document.getElementById('StoreSwitcherModal');
    bindModalListeners(modal);
  }

  document.addEventListener('click', handleTriggerClick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStoreSwitcher);
  } else {
    initStoreSwitcher();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initStoreSwitcher);
  }
})();
